import { useCallback } from 'react';
import { useRfqFiltersModalMethods } from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/modal-context';
import { useRfqFiltersValue } from '@paradigm/features/src/unified-rfqs/ui/rfq-filters/filter-provider';
import FilterButton from '#/components/FilterButton';
import { useTrackAction } from '@paradigm/features/src/analytics';

interface Props {
  readonly className?: string;
  readonly small?: boolean;
  readonly isBottomTab?: boolean;
}

export default function RfqFilterButton({
  className,
  small,
  isBottomTab,
}: Props) {
  const { open } = useRfqFiltersModalMethods();
  const { activeFiltersCount } = useRfqFiltersValue();
  const track = useTrackAction();

  const onOpen = useCallback(() => {
    open();
    track('view filters');
  }, [open, track]);

  return (
    <FilterButton
      isBottomTab={isBottomTab}
      ariaLabel="open rfq filters"
      onClick={onOpen}
      activeFiltersCount={activeFiltersCount}
      className={className}
      small={small}
    />
  );
}
